define('Cart.Lines.View.Extension', [
	'Cart.Lines.View',

	'Backbone',
	'jQuery',
	'Utils',
	'underscore'
], function (
	CartLinesView,

	Backbone,
	jQuery,
	Utils,
	_
) {
	'use strict';

	_.extend(CartLinesView.prototype, {
		getContext: _.wrap(CartLinesView.prototype.getContext, function (fn) {
			var context = fn.apply(this, _.toArray(arguments).slice(1));
			var config = SC.CONFIGURATION.get("inventoryDisplay");
			var threshold = config.lowStockThreshold;
			var quantAvailable = this.model.get('item').get('quantityavailable');
			var lowStock = false;
			if (quantAvailable && threshold && quantAvailable > 0 && quantAvailable < threshold)
			{
				lowStock = true;
			} 
			context.lowStock = lowStock;
			return context;
		})
	});
});